<template>
  <div>
    <div
      class="modal fade hide"
      id="sign-in"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sign-in"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">Logging in...</div>
        </div>
      </div>
    </div>

    <footer class="footer footer-container">
      <div class="white-line container"></div>
      <div class="container text-medium-size">
        <h2 class="title">Boomy</h2>

        <div class="text-secondary mb-0 mt-4">
          Boomy users have created
          <div class="mb-0 ml-1 songs-text">{{ stats.songCount }} songs</div>
          , around {{ stats.percentageAll }} of the world's recorded music.
        </div>
        <div class="buttons-container">
          <a
            class="btn mt-4"
            href="https://discord.gg/jpN78PRkQH"
            rel="noopener noreferrer"
            target="blank"
            data-mode="popup"
            ><img
              class="mr-2"
              src="../assets/svgs/discord.svg"
              alt="discord"
            />Join Discord</a
          >
          <a
            class="typeform-share btn addemailid mt-4"
            href="https://twitter.com/boomy"
            rel="noopener noreferrer"
            target="blank"
            data-mode="popup"
            ><img
              class="mr-2"
              src="../assets/svgs/twitter-with-background.svg"
              alt="twitter"
            />Follow @boomy</a
          >
          <a
            class="typeform-share btn addemailid mt-4 text-bold"
            href="https://boomy.typeform.com/to/pW2Gl0vy"
            rel="noopener noreferrer"
            target="blank"
            data-mode="popup"
            ><img class="mr-1" src="../assets/svgs/mail.svg" alt="say-hello" />
            Say hello</a
          >
        </div>
        <div>
          <br />
          <div class="table-container">
            <ul class="nav nav-footer pl-0">
              <li class="nav-item">
                <router-link :to="ROUTES.about.path">
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >About</span
                  >
                </router-link>
              </li>
              <li class="nav-item">
                <a
                  href="https://blog.boomy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >Blog</span
                  >
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="https://careers.boomy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >Careers</span
                  >
                </a>
              </li>
              <li class="nav-item">
                <router-link :to="ROUTES.eula.path" target="_blank">
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >EULA</span
                  >
                </router-link>
              </li>
              <!--              <li class="nav-item">-->
              <!--                <router-link :to="ROUTES.faqs.path" target="_blank">-->
              <!--                  <span-->
              <!--                    class="nav-link-footer mr-3 text-underline text-medium-size"-->
              <!--                    >FAQs</span-->
              <!--                  >-->
              <!--                </router-link>-->
              <!--              </li>-->
              <li class="nav-item">
                <router-link :to="ROUTES.privacy.path" target="_blank">
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >Privacy</span
                  >
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="ROUTES.terms.path" target="_blank">
                  <span
                    class="nav-link-footer mr-3 text-underline text-medium-size"
                    >Terms</span
                  >
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row align-items-center justify-content-md-between mt-2">
          <div class="col-md-12">
            <div class="copyright-text">
              <small>&#9439; &copy; 2020 Boomy Corporation </small> &middot;
              <small>1935 Addison St. Suite A Berkeley, CA 94704 </small>
              &middot;
              <small>510-730-3746</small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import StatsService from "@/services/Stats";
import AuthService from "@/services/Auth";
import { isStale } from "@/utils";
import { ROUTES } from "@/router/routes";

export default {
  data() {
    return {};
  },
  created() {
    this.ROUTES = ROUTES;
  },
  mounted() {
    const { fetchedAt, updateInterval } = this.stats;
    if (isStale(fetchedAt, updateInterval)) {
      // console.log(`stats stale: true`);
      this.getStats();
    }
  },
  methods: {
    async getStats() {
      await StatsService.getStats().then(
        result => {
          this.$store.dispatch("stats/setStats", result.data);
        },
        error => {
          console.log(error);
        }
      );
    }
  },
  watch: {
    $route() {
      // console.log(`routed to: ${to.path} from: ${from.path}`);
      const { fetchedAt, updateInterval } = this.stats;
      if (isStale(fetchedAt, updateInterval)) {
        // console.log(`stats stale: true`);
        this.getStats();
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    stats() {
      return this.$store.getters["stats/getStats"];
    },
    statsStale() {
      return this.$store.getters["stats/getStatsStale"];
    }
  }
};
</script>
<style scoped lang="scss">
.footer-container {
  background-color: #09090e;
  @media (max-width: 1024px) {
    padding-bottom: 94px;
  }
}

.nav-footer a:link {
  color: #efecfa !important;
}
.nav-footer a:visited {
  color: #efecfa !important;
}
.nav-footer a:hover {
  color: rgb(100, 100, 100) !important;
}

.text-medium-size {
  font-size: 14px;
}

.title {
  margin-top: 17px;
  font-size: 24px;
  line-height: 36px;
  text-transform: lowercase;
  color: #f81b55 !important;
  font-weight: 700 !important;
}

.songs-text {
  display: inline-flex;
  color: #21ecd8;
}

.buttons-container {
  display: flex;
  flex-wrap: wrap;
}

.buttons-container a {
  border-color: rgb(127, 74, 242);
  border-radius: 5px;
  color: #ffffff;
  padding: 0px;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
}

.table-container {
  padding: 0;
}

.copyright-text {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.04em;
  color: rgba(209, 194, 255, 0.7);
}

.white-line {
  width: 95%;
  max-width: 1100px;
  height: 1px;
  border-top: 1px solid rgba(209, 194, 255, 0.3);
}

.nav-item {
  margin-bottom: 10px;
}
.btn {
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    margin-right: 0 !important;
  }
}
</style>
